import React from 'react';
import { getFileViewUrl } from '../lib/appwrite';
import './CartDetailModal.css';

const formatImage = (img) => {
  if (!img) return null;
  const arr = Array.isArray(img) ? img : [img];
  const url = arr.find((u) => typeof u === 'string' && u);
  return url ? (url.startsWith('http') ? url : getFileViewUrl(url)) : null;
};

const CartDetailModal = ({
  mode,
  item,
  cart,
  formatCurrency,
  formatDateTime,
  onClose,
  onNavigateStore,
}) => {
  if (mode === 'item' && !item) return null;
  if (mode === 'cart' && !cart) return null;

  const formatImageUrl = (img) => formatImage(img);

  if (mode === 'item') {
    return (
      <div className="cart-detail-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="cart-detail-title">
        <div className="cart-detail-modal" onClick={(e) => e.stopPropagation()}>
          <div className="cart-detail-modal-header">
            <h2 id="cart-detail-title">Cart Item Details</h2>
            <button type="button" className="cart-detail-modal-close" onClick={onClose} aria-label="Close">
              ×
            </button>
          </div>
          <div className="cart-detail-modal-body">
            {item.image && formatImageUrl(item.image) && (
              <div className="cart-detail-modal-section">
                <h3>Product Image</h3>
                <img
                  src={formatImageUrl(item.image)}
                  alt={item.productName || 'Product'}
                  className="cart-detail-modal-image"
                />
              </div>
            )}
            <div className="cart-detail-modal-section">
              <h3>Product</h3>
              <div className="cart-detail-modal-grid">
                <div className="cart-detail-modal-field">
                  <label>Product</label>
                  <span>{item.productName || '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Product ID</label>
                  <span>{item.productId || '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Quantity</label>
                  <span>{item.quantity ?? '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Unit</label>
                  <span>{item.unit || '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Pack Size</label>
                  <span>{item.packSize ?? '—'}</span>
                </div>
              </div>
            </div>
            <div className="cart-detail-modal-section">
              <h3>Pricing</h3>
              <div className="cart-detail-modal-grid">
                <div className="cart-detail-modal-field">
                  <label>Unit Price (TZS)</label>
                  <span>{formatCurrency(item.price)}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Shipping Fee (TZS)</label>
                  <span>{formatCurrency(item.shippingFee)}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Shipping Option</label>
                  <span>{item.shippingOption || '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Line Total (TZS)</label>
                  <span><strong>{formatCurrency(item.lineTotal)}</strong></span>
                </div>
              </div>
            </div>
            <div className="cart-detail-modal-section">
              <h3>Parties</h3>
              <div className="cart-detail-modal-grid">
                <div className="cart-detail-modal-field">
                  <label>Customer</label>
                  <span>{item.userName || item.userId || '—'}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Store</label>
                  <span>
                    {onNavigateStore && item.storeId ? (
                      <button type="button" className="cart-detail-modal-link" onClick={() => onNavigateStore(item.storeId)}>
                        {item.storeName || item.storeId}
                      </button>
                    ) : (
                      item.storeName || item.storeId || '—'
                    )}
                  </span>
                </div>
              </div>
            </div>
            <div className="cart-detail-modal-section">
              <h3>Meta</h3>
              <div className="cart-detail-modal-grid">
                <div className="cart-detail-modal-field">
                  <label>Added</label>
                  <span>{formatDateTime(item.createdAt)}</span>
                </div>
                <div className="cart-detail-modal-field">
                  <label>Item ID</label>
                  <span className="cart-detail-modal-mono">{item.$id || '—'}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const items = cart.items || [];
  const total = items.reduce((sum, i) => sum + (parseFloat(i.lineTotal) || 0), 0);

  return (
    <div className="cart-detail-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="cart-detail-title">
      <div className="cart-detail-modal cart-detail-modal-wide" onClick={(e) => e.stopPropagation()}>
        <div className="cart-detail-modal-header">
          <h2 id="cart-detail-title">Cart — {cart.userName || cart.userId || 'Customer'}</h2>
          <button type="button" className="cart-detail-modal-close" onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className="cart-detail-modal-body">
          <div className="cart-detail-modal-section">
            <h3>Customer Cart</h3>
            <div className="cart-detail-modal-grid">
              <div className="cart-detail-modal-field">
                <label>Customer</label>
                <span>{cart.userName || cart.userId || '—'}</span>
              </div>
              <div className="cart-detail-modal-field">
                <label>Items</label>
                <span>{items.length}</span>
              </div>
              <div className="cart-detail-modal-field">
                <label>Cart Total</label>
                <span><strong>{formatCurrency(total)} TZS</strong></span>
              </div>
            </div>
          </div>
          <div className="cart-detail-modal-section">
            <h3>Items ({items.length})</h3>
            <div className="cart-detail-modal-table-wrap">
              <table className="cart-detail-modal-table">
                <thead>
                  <tr>
                    <th>Product</th>
                    <th>Store</th>
                    <th>Qty</th>
                    <th>Unit</th>
                    <th>Price</th>
                    <th>Shipping</th>
                    <th>Line Total</th>
                  </tr>
                </thead>
                <tbody>
                  {items.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="cart-detail-modal-empty">No items</td>
                    </tr>
                  ) : (
                    items.map((i) => (
                      <tr key={i.$id}>
                        <td>{i.productName || '—'}</td>
                        <td>
                          {onNavigateStore && i.storeId ? (
                            <button type="button" className="cart-detail-modal-link" onClick={() => onNavigateStore(i.storeId)}>
                              {i.storeName || i.storeId}
                            </button>
                          ) : (
                            i.storeName || i.storeId || '—'
                          )}
                        </td>
                        <td>{i.quantity ?? '—'}</td>
                        <td>{i.unit || '—'}</td>
                        <td>{formatCurrency(i.price)}</td>
                        <td>{formatCurrency(i.shippingFee)}</td>
                        <td><strong>{formatCurrency(i.lineTotal)}</strong></td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <td colSpan={6}><strong>Total</strong></td>
                    <td><strong>{formatCurrency(total)}</strong></td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartDetailModal;
